import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "../../../../assets/styles/common/tableHeader.scss";

interface Props {
  currentYear: number;
  minYear: number;
  maxYear: number;
  setCurrentYear: React.Dispatch<React.SetStateAction<number>>;
}

const YearPager: React.FC<Props> = ({
  currentYear,
  minYear,
  maxYear,
  setCurrentYear,
}) => (
  <div className="year-pager">
    <span
      style={{ visibility: currentYear > minYear ? "visible" : "hidden" }}
      onClick={() =>
        currentYear > minYear && setCurrentYear((prev) => prev - 1)
      }
    >
      <ChevronLeft size={20} />
    </span>
    <p>{currentYear}</p>
    <span
      style={{ visibility: currentYear < maxYear ? "visible" : "hidden" }}
      onClick={() =>
        currentYear < maxYear && setCurrentYear((prev) => prev + 1)
      }
    >
      <ChevronRight size={20} />
    </span>
  </div>
);

export default YearPager;
